import React from "react";

import { shallow } from "zustand/shallow";

import SidebarTabs from "@app/analytics/components/reports/SidebarTabs";
import {
  SidebarContentInnerContainer,
  SidebarHeader,
} from "@app/analytics/components/reports/styles";
import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";
import type { TopicReportSidebarTab } from "@app/analytics/TopicReport/types";

import { SidebarHeaderContainer, SidebarTab } from "./styles";
import TopicReportSidebarOverview from "./TopicReportSidebarOverview";
import TopicReportSources from "./TopicReportSources";

const TopicReportSidebarContent = ({
  tab,
}: {
  tab?: TopicReportSidebarTab;
}) => {
  const [selectedTab, setSelectedTab] = useTopicReportStore(
    (state) => [state.selectedSidebarTab, state.setSelectedSidebarTab],
    shallow
  );

  const handleChangeTab = (
    event: React.SyntheticEvent,
    value: TopicReportSidebarTab
  ) => setSelectedTab(value);

  const tabToShow = tab ?? selectedTab;

  return (
    <SidebarContentInnerContainer
      sx={{ backgroundColor: "#FFF", height: "100%", paddingBottom: 0 }}
    >
      {!tab && (
        <SidebarHeaderContainer>
          <SidebarHeader sx={{ paddingX: 2, backgroundColor: "#FFF" }}>
            <SidebarTabs value={selectedTab} onChange={handleChangeTab}>
              <SidebarTab label="Overview" value="overview" />
              <SidebarTab label="Sources" value="sources" />
            </SidebarTabs>
          </SidebarHeader>
        </SidebarHeaderContainer>
      )}
      {tabToShow === "overview" ? (
        <TopicReportSidebarOverview />
      ) : (
        <TopicReportSources />
      )}
    </SidebarContentInnerContainer>
  );
};

export default TopicReportSidebarContent;
